export type SkillCategory = 'Legal documents' | 'Data & sync' | 'AI & analysis' | 'Utilities';

export type SkillParamKind = 'select' | 'text' | 'textarea' | 'date';

export type SkillParamDef = {
  key: string;
  label: string;
  kind: SkillParamKind;
  placeholder?: string;
  required?: boolean;
  /** Runtime-resolved option lists (see SkillsView). */
  optionsKey?: 'bankAccounts' | 'legalEntities';
};

export type SkillDef = {
  id: string;
  title: string;
  description: string;
  category: SkillCategory;
  icon: string;
  mode: 'direct' | 'sidebar';
  params?: SkillParamDef[];
  buttonLabel?: string;
  longRunning?: boolean;
};

export const SKILL_CATEGORIES: SkillCategory[] = [
  'Legal documents',
  'Data & sync',
  'AI & analysis',
  'Utilities',
];

/** Skills are registered here as they are defined. */
export const SKILLS: SkillDef[] = [
  {
    id: 'dividend-shareholder-resolution',
    title: 'Gesellschafterbeschluss (Dividende)',
    description:
      'Generate a shareholder resolution PDF for a GmbH dividend distribution from your Google Docs template.',
    category: 'Legal documents',
    icon: 'signature',
    mode: 'sidebar',
    buttonLabel: 'Generate PDF',
    longRunning: true,
    params: [
      {
        key: 'legalEntityId',
        label: 'Legal entity',
        kind: 'select',
        optionsKey: 'legalEntities',
        placeholder: 'Select entity',
        required: true,
      },
      {
        key: 'companyRegister',
        label: 'Commercial register',
        kind: 'text',
        placeholder: 'e.g. HRB 123456, Amtsgericht München',
      },
      {
        key: 'fiscalYear',
        label: 'Fiscal year',
        kind: 'text',
        placeholder: 'e.g. 2025',
        required: true,
      },
      {
        key: 'dividendAmountEur',
        label: 'Dividend amount (EUR)',
        kind: 'text',
        placeholder: 'e.g. 50000',
        required: true,
      },
      {
        key: 'resolutionDate',
        label: 'Resolution date',
        kind: 'date',
      },
      {
        key: 'distributionDate',
        label: 'Distribution date',
        kind: 'date',
        required: true,
      },
      {
        key: 'managingDirector',
        label: 'Managing director',
        kind: 'text',
        placeholder: 'Full name',
        required: true,
      },
      {
        key: 'shareholdersBlock',
        label: 'Shareholders & signatures block',
        kind: 'textarea',
        placeholder:
          'One shareholder per line, e.g.\nMax Mustermann — 60 %\nErika Beispiel — 40 %',
        required: true,
      },
    ],
  },
];

export function skillById(id: string): SkillDef | undefined {
  return SKILLS.find((skill) => skill.id === id);
}
